import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/onboarding")({
	component: RouteComponent
});

function RouteComponent() {
	return <div className="h-screen w-screen bg-primary">Hello "/onboarding"!</div>;
}
